import { Box, Grid, Typography } from "@mui/material";
import type { ReactNode } from "react";
import type { GroupPosition } from "@/pages/sy/utils/layerGroups";
import {
  getGroupBackground,
  getGroupFrameBorder,
  getGroupHeaderDivider,
} from "@/pages/sy/utils/layerGroupFrame";

export type LayerGroupHeaderColumn = {
  size: number;
  content?: ReactNode;
};

export type LayerGroupFrame = {
  position: GroupPosition;
  layerNumber: number;
  labelSize: number;
  columns: LayerGroupHeaderColumn[];
};

type Props = {
  frame?: LayerGroupFrame;
  children: ReactNode;
};

export const LayerGroupBox = ({ frame, children }: Props) => {
  const isFirst = frame?.position === "first";
  const isLast = frame?.position === "last";

  return (
    <Box
      sx={
        frame &&
        ((theme) => ({
          borderLeft: getGroupFrameBorder(theme),
          borderRight: getGroupFrameBorder(theme),
          borderTop: isFirst ? getGroupFrameBorder(theme) : "none",
          borderBottom: isLast ? getGroupFrameBorder(theme) : "none",
          borderTopLeftRadius: isFirst ? 4 : 0,
          borderTopRightRadius: isFirst ? 4 : 0,
          borderBottomLeftRadius: isLast ? 4 : 0,
          borderBottomRightRadius: isLast ? 4 : 0,
          overflow: "hidden",
          mt: isFirst ? 0.5 : 0,
          mb: isLast ? 0.5 : 0,
        }))
      }
    >
      {isFirst && (
        <Grid
          container
          alignItems="center"
          sx={(theme) => ({
            bgcolor: getGroupBackground(theme),
            borderBottom: getGroupHeaderDivider(theme),
          })}
        >
          <Grid item xs={frame.labelSize} sx={{ px: "15px", py: 0.5 }}>
            <Typography variant="caption" sx={{ fontWeight: "bold" }}>
              Layer {frame.layerNumber}
            </Typography>
          </Grid>
          {frame.columns.map((column, index) => (
            <Grid
              key={index}
              item
              xs={column.size}
              sx={{ textAlign: "center" }}
            >
              <Typography variant="caption">{column.content}</Typography>
            </Grid>
          ))}
        </Grid>
      )}
      {children}
    </Box>
  );
};
